import styled, { keyframes } from "styled-components";

const fadeSlide = keyframes`
  from { opacity: 0; transform: translateY(18px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const AbCardWrapper = styled.div`
  background: #f5f7fa;
  padding: 60px 0 80px;

  .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;

    .card-item {
      background: #fff;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 4px 24px rgba(21, 82, 61, 0.08);
      border: 1.5px solid #e4ece8;
      display: flex;
      flex-direction: column;
      animation: ${fadeSlide} 0.5s ease both;
      transition: box-shadow 0.3s ease, transform 0.3s ease;

      &:hover {
        box-shadow: 0 12px 40px rgba(21, 82, 61, 0.16);
        transform: translateY(-4px);
      }

      .right-item {
        position: relative;
        width: 100%;
        height: 240px;
        overflow: hidden;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 50%;
          background: linear-gradient(
            to top,
            rgba(15, 45, 31, 0.7),
            transparent
          );
          border-radius: 0;
          pointer-events: none;
        }
      }

      &:hover .right-item img {
        transform: scale(1.06);
      }

      .left-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 16px;
        padding: 24px;
        flex: 1;

        .top-item {
          p {
            font-family: "Montserrat", sans-serif;
            font-weight: 600;
            font-size: 16px;
            line-height: 1.55;
            color: #1a3328;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }

        .bottom-item {
          a {
            text-decoration: none;
          }

          button,
          a > * {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: linear-gradient(135deg, #15523d, #1e7a58);
            color: #fff;
            font-family: "Montserrat", sans-serif;
            font-size: 13px;
            font-weight: 700;
            letter-spacing: 0.5px;
            padding: 10px 24px;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            transition: background 0.3s ease, box-shadow 0.3s ease;
            box-shadow: 0 4px 14px rgba(21, 82, 61, 0.25);

            &:hover {
              background: linear-gradient(135deg, #0f3d2c, #15523d);
              box-shadow: 0 6px 20px rgba(21, 82, 61, 0.35);
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    padding: 40px 0 60px;

    .container {
      gap: 20px;

      .card-item .right-item {
        height: 200px;
      }

      .card-item .left-item {
        padding: 20px;

        .top-item p {
          font-size: 14px;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 28px 0 48px;

    .container {
      grid-template-columns: 1fr;
      gap: 16px;

      .card-item {
        flex-direction: row;
        height: 160px;

        .right-item {
          width: 160px;
          height: 160px;
          flex-shrink: 0;
          border-radius: 0;
        }

        .left-item {
          padding: 16px;

          .top-item p {
            font-size: 13px;
            -webkit-line-clamp: 3;
          }

          .bottom-item button,
          .bottom-item a > * {
            font-size: 12px;
            padding: 8px 16px;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .container .card-item {
      flex-direction: column;
      height: auto;

      .right-item {
        width: 100%;
        height: 180px;
      }
    }
  }
`;